import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils/cn';

export function PageLoader({ className, label }: { className?: string; label?: string }) {
  return (
    <div
      className={cn(
        'flex min-h-[200px] flex-col items-center justify-center gap-2 text-muted-foreground',
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-5 w-5 animate-spin" />
      {label && <span className="text-xs">{label}</span>}
    </div>
  );
}
